import { TutorialProvider, Tutorials } from './../../providers/tutorial/tutorial';
import { Component, Input, OnInit } from '@angular/core';

import { ConfigProvider } from '../../providers/config/config';
import { AdsProvider } from '../../providers/ads/ads';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { ModalController, NavController } from '@ionic/angular';

@Component({
  selector: 'tutorials',
  templateUrl: 'tutorials.component.html',
  styleUrls:['./tutorials.component.scss']
})
export class TutorialsComponent implements OnInit{
  isEnabled: boolean = false;
  // tutorials: Tutorials;
  @Input() tutorials: Tutorials;
  currentTutorialIndex: number = 0;

  constructor(
    private config: ConfigProvider,
    private tutorialProvider: TutorialProvider,
    private ads:AdsProvider,
    private appDetector: AppDetectorProvider,
    private navCtrl:NavController,
    private modalCtrl:ModalController
    ) { 
    }

  // async ngOnInit(){
  //   if(window.screen.width>600){
  //     this.tutorialProvider.isLoginAllowed = true;
  //     return
  //   }
  //   this.tutorials = (await this.config.config).showHide.tutorials || {
  //     isEnabled: false,
  //     size: 0
  //   };
  //   console.log('this.tutorials', this.tutorials)

  //   this.tutorialProvider.isFirstRun("tutorials").then(isFirstRun => {
  //     this.isEnabled = isFirstRun && this.tutorials.isEnabled;
  //     if(this.isEnabled){
  //       this.tutorialProvider.isLoginAllowed = false;
  //     }
  //   });
  // }
  async ngOnInit() {
    if (!this.tutorials) {
      this.isEnabled = false;
      return;
    }

    const isFirstRun = await this.tutorialProvider.isFirstRun("tutorials");
    this.isEnabled = isFirstRun && this.tutorials.isEnabled;

    if(this.isEnabled){
      this.tutorialProvider.isLoginAllowed = false;
    }
    console.log('this.tutorials', this.tutorials)
  }
  onTapTutorial(){
    this.currentTutorialIndex++;
    let tutorialPage = this.tutorials.tabIndex[this.currentTutorialIndex];
    if (this.currentTutorialIndex >= this.tutorials.size) {
      this.isEnabled = false;
      this.tutorialProvider.isLoginAllowed = true;
      this.tutorialProvider.setTutorialDone("tutorials");
      // 
      this.tutorialProvider.isLoginAllowed = true;
      this.modalCtrl.dismiss();
      this.navCtrl.navigateForward('/tab1');
      
      // this.app.getRootNav().getActiveChildNav().select(0);
      return;
    }
    if(this.appDetector.isForestApp()){
      if(tutorialPage==0){
        tutorialPage=1
      }
      if(tutorialPage===2){
        tutorialPage = 4
      }
    }
    // this.app.getRootNav().getActiveChildNav().select(tutorialPage);
    this.navCtrl.navigateForward(`/tab${tutorialPage}`);
  }
  ionViewDidLeave(){
    this.ads.show();
  }
}

